import { useRef, useState } from "react";
import { FileText, X, GripVertical, ChevronLeft, ChevronRight } from "lucide-react";
import { absUrl } from "./aiApi";

const move = (arr, from, to) => {
  if (to < 0 || to >= arr.length || from === to) return arr;
  const x = [...arr];
  const [it] = x.splice(from, 1);
  x.splice(to, 0, it);
  return x;
};

export default function AIAttachTray({ files, setFiles }) {
  const drag = useRef(null);
  const [over, setOver] = useState(null);
  const multi = files.length > 1;
  return (
    <div className="mb-2" data-testid="ai-attach-tray">
      {multi && <div className="text-[10.5px] font-semibold text-slate-500 mb-1">Seret untuk susun halaman · Mimi gabung ikut susunan ini</div>}
      <div className="flex gap-1.5 overflow-x-auto pb-1 no-scrollbar">
        {files.map((f, i) => (
          <div key={f.id} draggable={multi} data-testid={`ai-attach-item-${i}`}
            onDragStart={() => { drag.current = i; }} onDragEnd={() => { drag.current = null; setOver(null); }}
            onDragOver={(e) => { e.preventDefault(); setOver(i); }}
            onDrop={(e) => { e.preventDefault(); setFiles((x) => move(x, drag.current, i)); setOver(null); }}
            className={`relative shrink-0 w-[68px] rounded-xl border bg-white p-1 transition-[transform,border-color] duration-150 ${multi ? "cursor-grab active:cursor-grabbing" : ""} ${over === i ? "border-fuchsia-400 scale-105" : "border-slate-200"}`}>
            {f.mime?.startsWith("image/")
              ? <img src={absUrl(f.url)} alt={f.filename} className="h-14 w-full rounded-lg object-cover pointer-events-none" />
              : <div className="h-14 grid place-items-center rounded-lg bg-slate-50"><FileText className="h-5 w-5 text-slate-400" /></div>}
            {multi && <span className="absolute top-0.5 left-0.5 h-4 min-w-4 px-1 rounded-full bg-fuchsia-600 text-white text-[9px] font-bold grid place-items-center" data-testid={`ai-attach-page-${i}`}>{i + 1}</span>}
            <button onClick={() => setFiles((x) => x.filter((y) => y.id !== f.id))} className="absolute -top-1 -right-1 h-4 w-4 rounded-full bg-slate-700 text-white grid place-items-center" aria-label="Buang" data-testid={`ai-attach-remove-${i}`}><X className="h-2.5 w-2.5" /></button>
            {multi && (
              <div className="flex items-center justify-between mt-0.5">
                <button onClick={() => setFiles((x) => move(x, i, i - 1))} disabled={i === 0} className="text-slate-400 hover:text-fuchsia-600 disabled:opacity-20" aria-label="Ke kiri" data-testid={`ai-attach-left-${i}`}><ChevronLeft className="h-3.5 w-3.5" /></button>
                <GripVertical className="h-3 w-3 text-slate-300" />
                <button onClick={() => setFiles((x) => move(x, i, i + 1))} disabled={i === files.length - 1} className="text-slate-400 hover:text-fuchsia-600 disabled:opacity-20" aria-label="Ke kanan" data-testid={`ai-attach-right-${i}`}><ChevronRight className="h-3.5 w-3.5" /></button>
              </div>
            )}
          </div>
        ))}
      </div>
    </div>
  );
}
